import InviteAdminForm from './InviteAdminForm'
import enhance from './InviteAdminForm.enhancer'

export default enhance(InviteAdminForm)



// WEBPACK FOOTER //
// ./src/components/organisms/InviteAdminForm/index.js